<template>
  <v-snackbar v-model="errorsExist" top multi-line vertical :timeout="timeout">
    <h3 class="text-center mb-4">Something went wrong.</h3>
    <ul v-if="errors.length > 0" justify="center">
      <li v-for="(error, index) in errors" :key="index">
        <v-icon color="white">mdi-alert-outline</v-icon>
        <span class="mr-3">
          {{ error }}
        </span>
      </li>
    </ul>
    <v-btn text @click="clearErrorsAndClose">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      timeout: 0 // Milliseconds. 0 value keeps it open.
    };
  },
  computed: {
    ...mapGetters({
      errors: 'errors'
    }),
    errorsExist: function () {
      return this.errors.length > 0;
    }
  },
  methods: {
    ...mapMutations({
      clearErrors: 'clearErrors'
    }),
    clearErrorsAndClose() {
      this.clearErrors();
      this.snackbar = false;
    }
  }
};
</script>

<style lang="scss" scoped>
ul li {
  list-style: none;
}
</style>
